import React, { FC } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-admin';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'nowrap',
        alignItems: 'center',
    },
    avatar: {
        marginRight: theme.spacing(1),
    },
}));


const UserLinkFieldOrder = ({ record, size }) => {
    const classes = useStyles();
    return record ? (
        <div className={classes.root}>
            <Link to={`/users/${record.user_id_raw}`} >{record.user_id}</Link>
        </div>
    ) : null;
};

export default UserLinkFieldOrder;
